import React, { Fragment } from "react";
import Interaction, {InteractionType} from "./Interaction";
import {GetNewGuid} from "../../helpers/GuidHelper";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { ValidationHelper } from "../../features/validation/ValidationHelper";
import HideLetterBoxNodePreview from "../../features/sequence/node_previews/HideLetterBoxNodePreview";

export interface IHideLetterBox extends Interaction {
    animationTime: number;
}

export const hideLetterBoxInteraction = (): InteractionFactoryEntity => {
    const component = <></>;

    const create = (getKeys: (amount: number) => string[]): IHideLetterBox => {
        return {
            id: GetNewGuid(),
            type: InteractionType.HideLetterBox,
            name: "Hide Letter Box",
            animationTime: 0.5,
        };
    };

    const migrate = (
        from: number,
        to: number,
        interaction: Interaction
    ): IHideLetterBox => {
        return interaction as IHideLetterBox;
    };

    const copy = (
        interaction: Interaction,
        getKeys: (amount: number) => string[],
        replaceKey: (from: string, to: string) => void
    ): IHideLetterBox => {
        return {
            id: GetNewGuid(),
            type: InteractionType.HideLetterBox,
            name: "Hide Letter Box",
            animationTime: (interaction as IHideLetterBox).animationTime,
        };
    };

    const validate = (
        interaction: Interaction,
        getValue: (key: string) => string
    ): string[] => {
        const hideLetterBox = interaction as IHideLetterBox;
        const warnings: string[] = [];

        return warnings;
    };

    const validateErrors = (interaction: Interaction): string[] => {
        const hideLetterBox = interaction as IHideLetterBox;
        const errors: string[] = [];

        if (hideLetterBox.animationTime < 0) {
            errors.push("Animation time cannot be negative");
        }

        return errors;
    };

    const filter = (
        interaction: Interaction,
        takeName: string,
        getMatchingResults: (
            searchableStrings: string[],
            takeName: string,
            interaction: Interaction,
            filterType: string
        ) => SearchResultData[]
    ): SearchResultData[] => {
        const converted = interaction as IHideLetterBox;
        const searchableStrings: string[] = [interaction.name];

        return getMatchingResults(
            searchableStrings,
            takeName,
            interaction,
            filterType
        );
    };

    const filterType: string = "Hide Letter Box";

    return {
        View: component,
        NodeView: (nodeId: string, interaction: Interaction) => (
            <HideLetterBoxNodePreview nodeId={nodeId} interaction={interaction} />
        ),
        FilterType: filterType,
        Create: create,
        Migrate: migrate,
        Copy: copy,
        Validate: validate,
        ValidateErrors: validateErrors,
        Filter: filter,
    };
};
